import { request, clear, error, finish } from './reducers/query';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    PAYMENTS_SEARCH_REQUEST: request,
    PAYMENTS_SEARCH_ERROR: error,
    PAYMENTS_SEARCH_FINISH: finish,
    PAYMENTS_SEARCH_CLEAR: clear,
});
